import EditContactEmail from './editContactEmail.modal.html';
import { find as _find } from 'lodash';
import { without as _without } from 'lodash';

class ContactPhonesController {
  constructor($scope, $uibModal, lookupService) {
    "ngInject";

    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.lookupService = lookupService;

    this.errMsg = '';
  }

  editContactEmail(eml) {
    this.errMsg = '';
    this.saveButtonTitle = 'Add';

    if (eml) {
      this.tempEmail = eml.email;

      eml.editMode = true;
      this.editEmail = eml;

      this.saveButtonTitle = 'Update';
    }

    this.$uibModalInstance = this.$uibModal.open({
        template: EditContactEmail,
        scope: this.$scope
    });
  }

  closeModal() {
    this.tempEmail = '';
    this.$uibModalInstance.close();

    if (this.editEmail) {
      this.editEmail.editMode = false;
    }
  }

  addEmail() {
    if (!this.tempEmail) {
      this.errMsg = 'Please enter a valid email address';
      return;
    }

    const email = _find(this.container.contactEmails, o => !o.editMode && o.email === this.tempEmail);
    if (email) {
      this.errMsg = 'This Email is already added to the list';
      return;
    }

    if (!this.editEmail) {
      this.container.contactEmails.push({
        email: this.tempEmail
      });
    }
    else {
      this.editEmail.email = this.tempEmail;
    }

    this.closeModal();
  }

  removeEmail(email) {
    this.container.contactEmails = _without(this.container.contactEmails, email);
  }
}

export default ContactPhonesController;



// WEBPACK FOOTER //
// ./client/app/components/common/contactEmails/contactEmails.controller.js